export type TestAccountFill = { email: string; password: string };

export function isLocalTestPage() {
  return process.env.NODE_ENV === "development" && ["http://localhost:4000", "http://127.0.0.1:4000"].includes(window.location.origin);
}

export async function readLocalTestAccount<T>(route: "accounts" | "fill", helperToken: string, input: object = {}, signal?: AbortSignal): Promise<T> {
  if (!helperToken || !isLocalTestPage()) throw new Error("LOCAL_ONLY");
  const response = await fetch(`http://127.0.0.1:4319/${route}`, {
    method: "POST", headers: { "Content-Type": "application/json", "X-Mira-Local-Helper": helperToken }, body: JSON.stringify(input),
    cache: "no-store", credentials: "omit", signal,
  });
  if (!response.ok) throw new Error("LOCAL_UNAVAILABLE");
  return response.json();
}

